import React, { FC } from 'react'
import { CircularProgress } from '@mui/material'

export const Spinner: FC = () => (
  <div className="Spinner">
    <CircularProgress />
  </div>
)
